import React from 'react';
import PropTypes from 'prop-types';
import { Link } from '@increase/typed-components';

const LOGIN_URL = import.meta.env.VITE_LOGIN_URL;

const ViewAsLink = ({ email }) => {
  if (!email) return null;

  const viewAsUrl = new URL('/view-as', LOGIN_URL);
  viewAsUrl.searchParams.set('email', email);

  return (
    <Link href={viewAsUrl.toString()} rel="noopener noreferrer" target="_blank">
      Ver como
    </Link>
  );
};

ViewAsLink.propTypes = {
  email: PropTypes.string
};

export default ViewAsLink;
